(() => {
  const instanceKey = Symbol.for('martguard.smartSearch');
  if (window[instanceKey]) { window[instanceKey].init(); return; }
  const initialized = new WeakSet();
  const init = () => document.querySelectorAll('[data-mg-smart-search]').forEach(form => {
    if (initialized.has(form)) return;
    initialized.add(form);
    const input = form.querySelector('[name=q]');
    const panel = form.querySelector('.mg-smart-panel');
    const body = form.querySelector('.mg-smart-body');
    const results = form.querySelector('.mg-smart-results');
    const all = form.querySelector('.mg-smart-all');
    const status = form.querySelector('.mg-smart-status');
    const config = JSON.parse(form.querySelector('[data-mg-search-config]').textContent);
    const root = window.Shopify?.routes?.root || '/';
    const terms = config.terms.split('|');
    const words = (config.locale.startsWith('fr') ? 'fouine fouines martre martres repulsif répulsif ultrasons solaire voiture jardin maison spray coussinets batterie' : 'marter marters marterverjager marterverjagers marterspray katten kattenverjager dierenverjager geurpads regenpijp regenpijpkraag auto tuin buiten binnen solar batterij batterijen ultrasoon ultrasone adapter').split(' ');
    let timer, controller, requestTimer, sequence = 0, active = -1, correction = '', originalOnly = false, renderedKey = '', renderedCorrection = '', pendingKey = '', composing = false;
    const cache = new Map();
    const node = (tag, text, className) => { const el = document.createElement(tag); if (text) el.textContent = text; if (className) el.className = className; return el; };
    const url = query => { const u = new URL(form.action, location.origin); u.searchParams.set('q', query); u.searchParams.set('type', 'product'); u.searchParams.set('options[prefix]', 'last'); return u.href; };
    const progress = node('div', config.loading, 'mg-smart-progress');
    progress.hidden = true; panel.querySelector('.mg-smart-heading').after(progress);
    const open = () => { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); };
    const select = index => {
      active = index;
      [...results.children].forEach((li, i) => li.setAttribute('aria-selected', String(i === index)));
      if (index >= 0) { input.setAttribute('aria-activedescendant', results.children[index].id); results.children[index].scrollIntoView({block:'nearest'}); }
      else input.removeAttribute('aria-activedescendant');
    };
    const key = () => JSON.stringify([input.value.trim().slice(0,200), originalOnly]);
    const busy = value => {
      form.toggleAttribute('data-search-loading', value);
      input.setAttribute('aria-busy', String(value));
      results.inert = value;
      progress.hidden = !value;
    };
    const cancel = () => { clearTimeout(timer); clearTimeout(requestTimer); controller?.abort(); controller = null; pendingKey = ''; sequence++; busy(false); };
    const close = () => { cancel(); panel.hidden = true; input.setAttribute('aria-expanded', 'false'); select(-1); };
    const choose = (value, original = false) => {
      cancel(); input.value = value; originalOnly = original; renderedKey = ''; correction = '';
      input.focus({preventScroll:true}); run();
    };
    const distance = (a, b) => {
      const d = Array.from({length:a.length + 1}, (_, i) => [i]);
      for (let j = 0; j <= b.length; j++) d[0][j] = j;
      for (let i = 1; i <= a.length; i++) for (let j = 1; j <= b.length; j++) {
        d[i][j] = Math.min(d[i-1][j]+1,d[i][j-1]+1,d[i-1][j-1]+(a[i-1] === b[j-1] ? 0 : 1));
        if(i>1 && j>1 && a[i-1]===b[j-2] && a[i-2]===b[j-1]) d[i][j]=Math.min(d[i][j],d[i-2][j-2]+1);
      }
      return d[a.length][b.length];
    };
    const correct = value => value.replace(/[\p{L}]+/gu, token => {
      const lower = token.toLocaleLowerCase();
      if (lower.length < 5 || words.some(word => word.startsWith(lower))) return token;
      const ranked = words.map(word => ({word, d:distance(lower,word)})).sort((a,b)=>a.d-b.d);
      const best = ranked[0];
      return best.d <= (lower.length >= 9 ? 2 : 1) && best.d < ranked[1].d ? best.word : token;
    });
    const chips = () => {
      const group = node('div', '', 'mg-smart-chips');
      terms.forEach(term => { const button = node('button', term, 'mg-smart-chip'); button.type = 'button'; button.addEventListener('click', () => {choose(term);}); group.append(button); });
      body.append(group);
    };
    const empty = () => { correction = ''; body.replaceChildren(node('p', config.popular)); chips(); results.replaceChildren(); all.hidden = true; status.textContent = ''; renderedKey = key(); busy(false); select(-1); };
    const fetchResults = async (query, signal) => {
      if (cache.has(query)) return cache.get(query);
      const endpoint = new URL(root + 'search/suggest.json', location.origin);
      endpoint.searchParams.set('q', query);
      endpoint.searchParams.set('resources[type]', 'product,query');
      endpoint.searchParams.set('resources[limit]', '6');
      endpoint.searchParams.set('resources[limit_scope]', 'each');
      endpoint.searchParams.set('resources[options][unavailable_products]', 'last');
      const response = await fetch(endpoint, {signal, headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('Search unavailable');
      const data = (await response.json()).resources.results;
      if (cache.size > 30) cache.delete(cache.keys().next().value);
      cache.set(query, data); return data;
    };
    const run = async () => {
      if (composing) return;
      clearTimeout(timer);
      const queryKey = key();
      open();
      if (pendingKey === queryKey || renderedKey === queryKey) return;
      cancel(); const current = sequence;
      const query = input.value.trim().slice(0,200); correction = ''; select(-1);
      if (!query) {empty();return;}
      pendingKey = queryKey;
      controller = new AbortController(); const signal = controller.signal;
      requestTimer = setTimeout(() => controller?.abort(), 8000);
      all.href = url(query); all.hidden = false;
      busy(true); status.textContent = config.loading;
      try {
        const candidate = originalOnly ? query : correct(query);
        let used = candidate, data = await fetchResults(candidate, signal);
        if (candidate !== query && !data.products?.length) {used = query;data = await fetchResults(query,signal);}
        if (current !== sequence || signal.aborted) return;
        correction = used !== query && data.products?.length ? used : '';
        body.replaceChildren();
        if (correction) {
          const p = node('p', config.corrected + ' '); p.append(node('strong', correction)); body.append(p);
          const original = node('button',config.original + ' “' + query + '”','mg-smart-original'); original.type='button'; original.addEventListener('click',()=>{choose(query, true);});body.append(original);
        }
        const products = data.products || [];
        const fragment = document.createDocumentFragment();
        const money = new Intl.NumberFormat(config.locale, {style:'currency',currency:config.currency || 'EUR'});
        products.forEach((product,i) => {
          const li = node('li','','mg-smart-result' + (product.available ? '' : ' is-unavailable')); li.id=results.id+'-'+i;li.setAttribute('role','option');li.setAttribute('aria-selected','false');
          const a=node('a');a.href=product.url;a.tabIndex=-1;
          const src=product.featured_image?.url || product.image;
          if(src){const img=node('img');const imageUrl=new URL(src,location.origin);imageUrl.searchParams.set('width','160');img.src=imageUrl.href;img.alt='';img.width=74;img.height=74;img.loading='lazy';a.append(img);}
          else a.append(node('span'));
          const details=node('span');details.append(node('strong',product.title),node('b',money.format(Number(product.price))),node('span',product.available ? config.available : config.sold_out,'mg-smart-availability'));a.append(details);li.append(a);fragment.append(li);
        });
        results.replaceChildren(fragment);
        if (!products.length) {body.append(node('p',config.empty));chips();}
        else if (!correction && data.queries?.length) {
          const group=node('div','','mg-smart-chips');data.queries.slice(0,3).forEach(suggestion=>{const b=node('button',suggestion.text,'mg-smart-chip');b.type='button';b.addEventListener('click',()=>{choose(suggestion.text);});group.append(b);});body.append(group);
        }
        renderedKey = queryKey; renderedCorrection = correction;
        all.href=url(correction || query);all.hidden=false;
        status.textContent=products.length ? products.length+' '+config.count : config.empty;
      } catch(error) {
        if(current!==sequence)return;
        results.replaceChildren();body.replaceChildren(node('p',config.error));all.href=url(query);all.hidden=false;status.textContent=config.error;
      } finally {if(current===sequence){clearTimeout(requestTimer);pendingKey='';controller=null;busy(false);}}
    };
    const schedule = () => {
      originalOnly = false; correction = ''; cancel(); select(-1); open();
      if (!input.value.trim()) {empty();return;}
      if (renderedKey === key()) {correction=renderedCorrection;return;}
      all.href=url(input.value.trim());all.hidden=false;busy(true);status.textContent=config.loading;
      timer=setTimeout(run,180);
    };
    input.addEventListener('input',()=>{if(!composing)schedule();});
    input.addEventListener('compositionstart',()=>{composing=true;cancel();});
    input.addEventListener('compositionend',()=>{composing=false;schedule();});
    const reveal = () => {if(input.value.trim())run();else {empty();open();}};
    input.addEventListener('focus',reveal);
    input.addEventListener('click',()=>{if(panel.hidden)reveal();});
    input.addEventListener('keydown',event=>{
      if(event.isComposing || composing) return;
      if(event.key==='Escape'){event.preventDefault();close();return;}
      if(['ArrowDown','ArrowUp'].includes(event.key)&&results.children.length&&!results.inert){event.preventDefault();open();select(active < 0 ? (event.key==='ArrowDown' ? 0 : results.children.length-1) : (active+(event.key==='ArrowDown'?1:-1)+results.children.length)%results.children.length);}
      if(event.key==='Enter'&&!panel.hidden&&!results.inert&&active>=0){event.preventDefault();results.children[active].querySelector('a').click();}
    });
    form.addEventListener('submit',()=>{if(correction && renderedKey===key())input.value=correction;cancel();});
    form.addEventListener('reset',()=>{cancel();renderedKey='';correction='';originalOnly=false;setTimeout(()=>{empty();close();},0);});
    window.addEventListener('pagehide',close);
    form.querySelector('.mg-smart-close').addEventListener('click',close);
    document.addEventListener('pointerdown',event=>{if(!form.contains(event.target))close();});
    form.addEventListener('focusout',()=>{setTimeout(()=>{if(!form.contains(document.activeElement))close();},0);});
    if (document.activeElement === input) reveal();
  });
  window[instanceKey] = {init};
  window.addEventListener('pageshow',init);
  init();
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  document.addEventListener('shopify:section:load',init);
})();
